let invoiceDebugState = {
  customerEmail: "",
  customerId: "",
  companyName: "",
  locationName: "",
  custId: "",
  token: "",
  dateRange: "",
  fromDate: "",
  toDate: "",
  apiUrl: "",
  httpStatus: "",
  invoiceCount: "",
  lastError: "",
};

function updateInvoiceDebugPanel(patch = {}) {
  invoiceDebugState = { ...invoiceDebugState, ...patch };
  const debugPanel = document.getElementById("gv-invoice-debug-panel");
  if (!debugPanel) return;

  Object.keys(invoiceDebugState).forEach((key) => {
    const field = debugPanel.querySelector(`[data-debug-field="${key}"]`);
    if (field) {
      field.textContent = invoiceDebugState[key] === "" ? "-" : invoiceDebugState[key];
    }
  });
}

// Function to fetch invoice data from the API
async function fetchInvoices(custId, fromDate, toDate, token) {
  const apiUrl = `https://app.russellhendrix.com/api/external/invoice/invoices?custId=${custId}&fromDate=${fromDate}&toDate=${toDate}&unpaidOnly=false&token=${encodeURIComponent(token)}`;
  updateInvoiceDebugPanel({ apiUrl, lastError: "", httpStatus: "" });

  try {
    const response = await fetch(apiUrl);
    updateInvoiceDebugPanel({ httpStatus: `${response.status} ${response.statusText}` });

    if (!response.ok) {
      const fallbackError = `Invoice API request failed (${response.status} ${response.statusText})`;
      updateInvoiceDebugPanel({ lastError: fallbackError });
      return { error: fallbackError, invoices: [] };
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error fetching invoices:", error);
    updateInvoiceDebugPanel({ lastError: error?.message || "Unknown fetch error" });
    return { error: error?.message || "Unknown fetch error", invoices: [] };
  }
}


// Function to format the date as reader-friendly
function formatDate(dateString) {
  const date = new Date(dateString);
  const monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  return `${
    monthNames[date.getMonth()]
  } ${date.getDate()}, ${date.getFullYear()}`;
}

// Billing address object, to be used when paying invoices
let billingAddress = {};
billingAddress.ordName = "";
billingAddress.ordEmailAddress = "";
billingAddress.ordAddress1 = "";
billingAddress.ordAddress2 = "";
billingAddress.ordPhoneNumber = "";
billingAddress.ordCity = "";
billingAddress.ordProvince = "";
billingAddress.ordPostalCode = "";
billingAddress.ordCountry = "";

// Function to render invoices
async function renderInvoices() {
  const invoicesContainer = document.querySelector(".gv-order-invoices");
  invoicesContainer.innerHTML = "Loading invoices..."; // set loading message

  // Get the customer email and fill in the billing address object
  billingAddress.ordEmailAddress = invoicesContainer.dataset.customeremail;
  updateInvoiceDebugPanel({
    customerEmail: invoicesContainer.dataset.customeremail || "",
    customerId: invoicesContainer.dataset.customerid || "",
    companyName: invoicesContainer.dataset.companyname || "",
  });

  // Get the selected customer ID from location dropdown
  const locationSelector = document.getElementById("gv-company_locations");
  if (typeof locationSelector == "undefined" || locationSelector == null) {
    invoicesContainer.innerHTML = "No invoices to display"; // if no location is mapped then the page doesn’t need to render
    return;
  }

  const custId = locationSelector.value;
  const token = locationSelector.options[locationSelector.selectedIndex].dataset.token;
  const locationName = locationSelector.options[locationSelector.selectedIndex].text;
  updateInvoiceDebugPanel({
    locationName,
    custId,
    token,
  });

  // Get selected date range
  const dateSelector = document.getElementById("gv-order-dateSelector");
  const selectedDateRange = dateSelector.value;
  let fromDate, toDate;

  // Calculate from and to dates based on the selected range
  const today = new Date();
  switch (selectedDateRange) {
    case "last6Months":
      fromDate = new Date(today.getFullYear(), today.getMonth() - 5, 1);
      toDate = today;
      break;
    case "lastYear":
      fromDate = new Date(
        today.getFullYear() - 1,
        today.getMonth(),
        today.getDate()
      );
      toDate = today;
      break;
    default:
      // If the selected option is a specific year, set the date range accordingly
      const selectedYear = parseInt(selectedDateRange);
      fromDate = new Date(selectedYear, 0, 1); // January 1st of the selected year
      toDate = new Date(selectedYear, 11, 31); // December 31st of the selected year
      break;
  }

  // Fetch invoices based on customer ID and date range
  const responseData = await fetchInvoices(
  custId,
  fromDate.toISOString(),
  toDate.toISOString(),
  token
  );
  updateInvoiceDebugPanel({
    dateRange: selectedDateRange,
    fromDate: fromDate.toISOString(),
    toDate: toDate.toISOString(),
  });


  // console.log(responseData);
  // Check if the responseData is valid and contains invoices
  if (
    !responseData ||
    !responseData.invoices ||
    responseData.invoices.length === 0
  ) {
    // If no data is found, display the message
    invoicesContainer.innerHTML =
      "<p>No invoice data found for selected parameters.</p>";
    updateInvoiceDebugPanel({
      invoiceCount: "0",
      lastError: responseData?.error || responseData?.message || invoiceDebugState.lastError,
    });
    return;
  }

  updateInvoiceDebugPanel({
    invoiceCount: String(responseData.invoices.length),
  });

  // Render invoices
  const invcTable = document.createElement("table");
  invcTable.className = "gv-invoices-tbl";
  const invcThead = document.createElement("thead");
  invcThead.innerHTML = `<tr><th></th>
    <th>Invoice #</th>
    <th>Online Order #</th>
    <th>Order Date</th>
    <th>Due Date</th>
    <th>Total</th>
    <th>Total Items</th>
    <th>Net Due</th>
    <th>Status</th>
    </tr>`;
  invcTable.appendChild(invcThead);
  const invcTbody = document.createElement("tbody");

  // Fill in the billing address
  billingAddress.ordName = responseData.invoices[0].custName;
  billingAddress.ordAddress1 = responseData.invoices[0].billToAddr1;
  if (responseData.invoices[0].billToAddr2 != null)
    billingAddress.ordAddress2 = responseData.invoices[0].billToAddr2;
  billingAddress.ordPhoneNumber = responseData.invoices[0].billToPhone;
  billingAddress.ordCity = responseData.invoices[0].billToCity;
  billingAddress.ordProvince = responseData.invoices[0].billToRegion;
  billingAddress.ordPostalCode = responseData.invoices[0].billToPostalCode;
  billingAddress.ordCountry = responseData.invoices[0].billToCountry;

  responseData.invoices.forEach((invoice) => {
    const invoiceElement = document.createElement("tr");
    const trackingElement = document.createElement("tr");
    trackingElement.classList.add("gv-tracking");

    // Format date
    const formattedDate = formatDate(invoice.orderDate);

    // Due date for the invoice
    const invoiceDueDate = formatDate(invoice.netDueDate);

    // Format order total with $
    const formattedOrderTotal = invoice.total != null ? `$${parseFloat(invoice.total).toFixed(2)}` : `$0.00`;

    // Format balance due total with $
    const balDueValue =
      invoice.balDue != null ? parseFloat(invoice.balDue) : 0;
    const balDueAmount = balDueValue.toFixed(2);
    var formattedBalDueTotal = `$${balDueAmount.replace(
      /\d(?=(\d{3})+\.)/g,
      "$&,"
    )}`;

    // Format item count
    let itemCountText = invoice.orderItemsCount != null ? invoice.orderItemsCount : '';

    if (invoice.orderItemsCount === 0) {
      itemCountText = "";
    }

    // Determine payment status
    let paymentStatus = "Unpaid";
    let paymentStatusIcon = "fa-exclamation-circle";
    let paymentStatusClass = "gv-text-red";
    const transType =
      typeof invoice.transType !== "undefined"
        ? Number(invoice.transType)
        : NaN;

    if (transType === -1) 
    {
      paymentStatus = "Credited";
      paymentStatusIcon = "fa-minus-circle";
      paymentStatusClass = "gv-text-blue";
    } 
    else if (transType === 1) 
    {
      if (balDueValue === 0) {
        paymentStatus = "Paid";
        paymentStatusIcon = "fa-check-circle";
        paymentStatusClass = "gv-text-green";
      } else if (balDueValue > 0) {
        paymentStatus = "Unpaid";
        paymentStatusIcon = "fa-exclamation-circle";
        paymentStatusClass = "gv-text-red";
      }
    } 
    else if (!isNaN(balDueValue)) 
    {
      if (balDueValue < 0) {
        paymentStatus = "Credited";
        paymentStatusIcon = "fa-minus-circle";
        paymentStatusClass = "gv-text-blue";
      } else if (balDueValue === 0) {
        paymentStatus = "Paid";
        paymentStatusIcon = "fa-check-circle";
        paymentStatusClass = "gv-text-green";
      } else if (balDueValue > 0) {
        paymentStatus = "Unpaid";
        paymentStatusIcon = "fa-exclamation-circle";
        paymentStatusClass = "gv-text-red";
      }
    }

    let trackingButton = "";
    if (invoice.trackingDetails && invoice.trackingDetails.length > 0) {
      trackingButton = `<button onclick="toggleNextRow(this)" class="gv-tracking-btn">Tracking</button>`;
    }

    // Render invoices if available, otherwise render a default message
    let invoicesHtml = "";
    if (paymentStatus === "Credited") {
      invoicesHtml = `<span class="gv-text-red">${invoice.invcNum}</span> ${trackingButton}`;
    } else {
      invoicesHtml = `<a class="gv-text-red" target="_blank" href="/pages/invoices?invoiceNumber=${invoice.invcNum}&transId=${invoice.transID}&view=invoice&ref=${encodeURIComponent(token)}">${invoice.invcNum}</a> ${trackingButton}`;
    }

    //Shopify order
    let onlineOrderNumber =
      invoice.shopifyOrderName != null ? invoice.shopifyOrderName : "";
    let shopifyOrderID =
      invoice.shopifyOrderId != null ? invoice.shopifyOrderId : "";
    const shopifyOrderIsFullyPaid = invoice.shopifyOrderFullyPaid === true;
    let shopifyOrderCancelled =
      invoice.shopifyOrderCancelledAt == null ? "" : "Cancelled";

    //If it's an online order and Paid/Cancelled, it takes precendence over the traverse status
    if (shopifyOrderCancelled == "Cancelled") {
      paymentStatus = shopifyOrderCancelled;
      paymentStatusIcon = "fa-minus-circle";
      paymentStatusClass = "gv-text-blue";
    } else if (shopifyOrderID != "" && shopifyOrderIsFullyPaid) {
      paymentStatus = "Paid";
      paymentStatusIcon = "fa-check-circle";
      paymentStatusClass = "gv-text-green";
      formattedBalDueTotal = "$0.00";
    }

    // Concatenate invoice if available
    let payInvoiceNums = invoice.invcNum;

    // Invoice pay checkbox
    // let payInvoiceHTML = invoice.invcPaid || balDueValue < 0
    //  ? ``
    //  : `<input type="checkbox" data-invoice="${payInvoiceNums}" data-amount="${balDueAmount}" data-custID="${custId}" class="gv-pay-invoice">`;

    var payInvoiceHTML = "";

    //if paymentStatus = Credited then no need to show the payment options
    if (paymentStatus !== "Credited") {
      const hasBalanceDue = balDueValue > 0;

      if (!shopifyOrderIsFullyPaid && shopifyOrderID !== "" && hasBalanceDue) {
        payInvoiceHTML = `<a class="button--tertiary button gv-pay-invoice-button gv-p-0"
          href="https://account.russellhendrix.com/orders/${shopifyOrderID}"
          target="_blank">Pay now</a>`;
      } else if (hasBalanceDue && paymentStatus !== "Paid") {
        payInvoiceHTML = `<input type="checkbox"
          data-invoice="${payInvoiceNums}"
          data-amount="${balDueAmount}"
          data-custID="${custId}"
          class="gv-pay-invoice">`;
      }
    }

    // Format Invoices label
    const invoicesLabel = `Invoice`;

    if (invoice.invcNum > 0) {
      invoiceElement.classList.add("gv-invoice-" + paymentStatus);
      invoiceElement.innerHTML = `<td>
                                  ${payInvoiceHTML}
                                </td>
                               
                                <td>
                                  ${invoicesHtml}
                                </td>  
                                 <td>
                                ${onlineOrderNumber}
                                </td>
                                <td>
                                  ${formattedDate}
                                </td>
                                <td>
                                  ${invoiceDueDate}
                                </td>
                                <td>
                                  ${formattedOrderTotal} 
                                </td>
                                <td>
                                  ${itemCountText}
                                </td>
                                <td>
                                  ${formattedBalDueTotal}
                                </td>
                                <td>
                                   <div class="gv-order-status"><i class="fa ${paymentStatusIcon} ${paymentStatusClass}"></i> ${paymentStatus}</div>
                                </td> `;
    }

    // Render shipment tracking details if available
    let shipmentTrackingHtml = "";
    if (invoice.trackingDetails && invoice.trackingDetails.length > 0) {
      shipmentTrackingHtml = '<div class="gv-o-shipment-tracking">';
      shipmentTrackingHtml += '<div class="gv-tracking-list"><ul>';
      invoice.trackingDetails.forEach((tracking) => {
        shipmentTrackingHtml += "<li>";
        if (tracking.trackingUrl) {
          shipmentTrackingHtml += `<a class="gv-text-red" target="_blank" href="${tracking.trackingUrl}">${tracking.trackingNumber}</a>`;
        } else {
          shipmentTrackingHtml += `${tracking.trackingNumber}`;
        }
        shipmentTrackingHtml += ` (${tracking.trackingCompany})`;
        shipmentTrackingHtml += "</li>";
      });
      shipmentTrackingHtml += "</ul></div></div>";
    }

    invcTbody.appendChild(invoiceElement);
    if (shipmentTrackingHtml !== "") {
      trackingElement.innerHTML =
        "<td colspan='9'>" + shipmentTrackingHtml + "</td>";
      invcTbody.appendChild(trackingElement);
    }
  });

  invcTable.appendChild(invcTbody);
  invoicesContainer.innerHTML = ""; // Clear previous content
  invoicesContainer.appendChild(invcTable);
}

// Call the renderInvoices function to initially render invoices
renderInvoices();

// Add event listener for date range selector change
document
  .getElementById("gv-order-dateSelector")
  .addEventListener("change", renderInvoices);

// Add event listener for location dropdown change
const company_locations = document.getElementById("gv-company_locations");
if (typeof company_locations != "undefined" && company_locations != null) {
  company_locations.addEventListener("change", renderInvoices);
}
// Populate the year options dynamically
const yearSelector = document.getElementById("gv-order-dateSelector");
const currentYear = new Date().getFullYear();
for (let year = currentYear; year >= currentYear - 2; year--) {
  const option = document.createElement("option");
  option.value = year.toString();
  option.textContent = year.toString();
  yearSelector.appendChild(option);
}

// Function to pay invoices
function payInvoices() {
  const checkboxes = document.querySelectorAll(".gv-pay-invoice");

  // Array to hold the invoice numbers and variable to sum amounts
  let invoices = [];
  let totalAmount = 0;
  let custID = "";

  // Iterate over each checkbox
  checkboxes.forEach((checkbox) => {
    // Collect data-invoice values and sum data-amount values
    if (checkbox.checked) {
      invoices.push(checkbox.dataset.invoice);
      totalAmount += parseFloat(checkbox.dataset.amount);
      custID = checkbox.dataset.custid;
    }
  });

  // If any invoice selected to pay
  if (invoices.length > 0) {
    let orderNumber = "MultipleRef3";
    if (invoices.length == 1) {
      orderNumber = invoices[0];
    }
    // Join invoice numbers
    const invoiceString = "inv" + invoices.join("inv");

    let url = `https://web.na.bambora.com/scripts/payment/payment.asp?merchant_id=117585868&hashValue=f90004dd22a67cdfaaeea9aff9bfd1de9f9270dc&trnLanguage=eng&trnAmount=${totalAmount.toFixed(
      2
    )}&trnOrderNumber=${orderNumber}&Ref1=${custID}&trnComments=&Ref2=Shopify&Ref3=${invoiceString}`;

    // Billing address
    url += `&ordName=${billingAddress.ordName}&ordEmailAddress=${billingAddress.ordEmailAddress}&ordPhoneNumber=${billingAddress.ordPhoneNumber}&ordAddress1=${billingAddress.ordAddress1}&ordAddress2=${billingAddress.ordAddress2}&ordCity=${billingAddress.ordCity}&ordProvince=${billingAddress.ordProvince}&ordPostalCode=${billingAddress.ordPostalCode}&ordCountry=${billingAddress.ordCountry}`;
    window.open(url, "_blank");
  }
}

// Show tracking info
function toggleNextRow(button) {
  const currentRow = button.closest("tr");
  const nextRow = currentRow.nextElementSibling;

  if (nextRow.classList.contains("gv-tracking-show")) {
    nextRow.classList.remove("gv-tracking-show");
  } else {
    nextRow.classList.add("gv-tracking-show");
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const debugToggle = document.getElementById("gv-invoice-debug-toggle");
  const debugPanel = document.getElementById("gv-invoice-debug-panel");
  if (debugToggle && debugPanel) {
    debugToggle.addEventListener("click", () => {
      const isOpen = !debugPanel.hidden;
      debugPanel.hidden = isOpen;
      debugToggle.setAttribute("aria-expanded", String(!isOpen));
    });
  }

  const checkbox = document.querySelector("#chk-gv-show-unpaid-only");

  // Add click event listener to the checkbox to show and hide unpaid invoice
  checkbox.addEventListener("click", function () {
    const paidRows = document.querySelectorAll(".gv-invoice-Paid");

    // Check the state of the checkbox
    if (this.checked) {
      // Hide all rows with class "gv-invoice-Paid"
      paidRows.forEach((row) => {
        row.style.display = "none";
      });
    } else {
      const allRows = document.querySelector(".gv-invoices-tbl tbody").rows;

      // Show all rows
      for (let row of allRows) {
        row.style.display = "";
      }
    }
  });

  document
    .querySelector(".gv-pay-invoice-btn")
    .addEventListener("click", function () {
      payInvoices();
    });
});
